import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {ensureNotObject} from "../common";

export function RenderDeleteRenovationCostCategories(props: RendererProps): ReactElement {
    const ids = props.variables["ids"];
    return <>{Array.isArray(ids) ? ids.map(v => ensureNotObject(v).toString()).join(", ") : ensureNotObject(ids)}</>;
}